import { AxiosError } from 'axios';
import swal from 'sweetalert';

export type ValidationErrors = {
    [fieldName: string]: string[];
};

export default function handleValidationErrors(
    error: Error | AxiosError,
    errorsCallback?: (errors: ValidationErrors) => void
) {
    const errObj = ((error as AxiosError)?.response?.data as any) ?? error;

    if (errorsCallback && errObj?.errors) {
        errorsCallback(errObj.errors);
    } else {
        const text = errObj?.message || 'Something went wrong...';
        swal({ title: 'Error', text, icon: 'error' });
    }
}

export function handleResponseError(error: Error | AxiosError) {
    const errObj = ((error as AxiosError)?.response?.data as any) ?? error;
    const text = errObj?.message || 'Something went wrong...';
    swal({ title: 'Error', text, icon: 'error' });
}
